import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-list-item" }
const _hoisted_2 = { class: "date-item" }
const _hoisted_3 = { class: "icon-container" }

import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import NDatePicker from '@/shared/designsystem/components/input/date-picker/date-picker.vue';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayDateInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "delete"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const dateValue = useVModel(props, 'modelValue', emit);
const dateInput = ref<InstanceType<typeof NDatePicker> | null>(null);

// Validation
const rules = {
  date: {
    required,
    todayOrFutureValid: VuelidateUtil.todayOrFuture,
  },
};

const $v = useVuelidate(rules, { date: dateValue });

function getErrorMessage(label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, 'date', label, (failedRule) => {
    if (VuelidateUtil.isValidationInvalid($v, 'date', 'todayOrFutureValid'))
      return `${label} must be today or in the future`;
    return null;
  });
}

function deleteDate() {
  emit('delete');
}

// Expose for focusing
__expose({ focus: () => focusOnInput(dateInput.value) });

function focusOnInput(component?: InstanceType<typeof NDatePicker> | null) {
  if (component) {
    const inputElements = component.$el.getElementsByTagName('input');
    if (inputElements.length === 1) {
      inputElements[0].focus();
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NDatePicker, {
        ref_key: "dateInput",
        ref: dateInput,
        modelValue: _unref(dateValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateValue) ? (dateValue).value = $event : null)),
        min: new Date(),
        max: new Date(3000, 11, 31),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).date.$touch())),
        "error-message": getErrorMessage('Date')
      }, null, 8, ["modelValue", "min", "max", "error-message"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", {
          onClick: deleteDate,
          class: "trash-icon"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("use", {
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xlink:href": "#trash"
          }, null, -1)
        ]))]))
      ])
    ])
  ]))
}
}

})